export const KNOWLEDGE_BASE_URL = {
  PREBID_BIDDERS: 'https://knowledge-base.yieldbird.com/prebid-stack/bidders',
} as const
